export default __webpack_public_path__ + "static/media/US2.35a0bdd7.png";